import { render, staticRenderFns } from "./relationship_type_list.vue?vue&type=template&id=a4ef9be8&"
import script from "./relationship_type_list.vue?vue&type=script&lang=js&"
export * from "./relationship_type_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3094448754/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4ef9be8')) {
      api.createRecord('a4ef9be8', component.options)
    } else {
      api.reload('a4ef9be8', component.options)
    }
    module.hot.accept("./relationship_type_list.vue?vue&type=template&id=a4ef9be8&", function () {
      api.rerender('a4ef9be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/relationship_type_list.vue"
export default component.exports